import { z } from 'zod';

const GET_PACKAGINGS_MAX_CHUNK_SIZE = 50;

export const getPackagingsQuerySchema = z.object({
    shipment_ids: z
        .array(z.string())
        .min(1)
        .max(
            GET_PACKAGINGS_MAX_CHUNK_SIZE,
            `Maximum of ${GET_PACKAGINGS_MAX_CHUNK_SIZE} shipment IDs allowed per request`
        ),
});

const packagingLineItemContentSchema = z.object({
    code: z.string(),
    description: z.string().nullish(),
    quantity: z.int32(),
});

const packagingLineItemSchema = z.object({
    id: z.string(),
    code: z.string(),
    description: z.string().nullish(),
    quantity: z.int32(),
    weight_kg: z.number(),
    volume_m3: z.number(),
    packaging_component_ids: z.array(z.string()),
    content: z.array(packagingLineItemContentSchema),
});

const packagingSchema = z.object({
    shipment_id: z.string(),
    packaging_id: z.string(),
    total_line_items: z.int32(),
    total_weight_kg: z.number(),
    total_volume_m3: z.number(),
    line_items: z.array(packagingLineItemSchema),
});

export const getPackagingsResponseSchema = z.object({
    items: z.array(packagingSchema),
});

export type ApiGetPackagingsResponse = z.infer<typeof getPackagingsResponseSchema>;
export type ApiPackaging = z.infer<typeof packagingSchema>;
export type ApiPackagingLineItem = z.infer<typeof packagingLineItemSchema>;
export type ApiPackagingLineItemContent = z.infer<typeof packagingLineItemContentSchema>;
export type ApiGetPackagingsQuery = z.infer<typeof getPackagingsQuerySchema>;
